@for (postAdress of addresses; track postAdress) {
  @if (postAdress.room) {
    <div>{{postAdress.room}}</div>
  }
  @if (postAdress.floor) {
    <div>{{postAdress.floor}}</div>
  }
  @if (postAdress.building) {
    <div>{{postAdress.building}}</div>
  }
  @if (postAdress.street) {
    <div>{{postAdress.street}}</div>
  }
  @if (postAdress.postcode && postAdress.city) {
    <div>{{postAdress.postcode}} {{postAdress.city}}</div>
  }
  @if (postAdress.country) {
    <div>{{postAdress.country}}</div>
  }
  <br />
}
